import { render, staticRenderFns } from "./ArchiveSettings.vue?vue&type=template&id=7d7f5e3e&scoped=true"
import script from "./ArchiveSettings.vue?vue&type=script&lang=js"
export * from "./ArchiveSettings.vue?vue&type=script&lang=js"
import style0 from "./ArchiveSettings.vue?vue&type=style&index=0&id=7d7f5e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7f5e3e",
  null
  
)

export default component.exports